/* ============================================================
   PRODUCT LABEL OVERLAYS — RENDER FUNCTION
   ============================================================ */

function renderProductLabelOverlays(el) {
  try {
    // Handle Shopify returning "null"
    const rawLabels = el.dataset.labels;
    const labels = rawLabels && rawLabels !== 'null' ? JSON.parse(rawLabels) : [];

    const rawMap = el.dataset.gidmap;
    const gidMap = rawMap && rawMap !== 'null' ? JSON.parse(rawMap) : {};

    // Replace gid:// IDs with real CDN URLs
    labels.forEach(l => {
      if (l.label_image && l.label_image.includes('gid://')) {
        const id = l.label_image.split('/').pop();
        if (gidMap[id]) l.image_url = gidMap[id];
      }
    });

    // Sort by priority
    labels.sort((a, b) => (a.priority_order || 0) - (b.priority_order || 0));

    // Group by position
    const groups = {
      'top-left': [], 'top-right': [],
      'bottom-left': [], 'bottom-right': []
    };

    labels.forEach(l => {
      const pos = (l.position || 'top-left').toLowerCase();
      if (groups[pos]) groups[pos].push(l);
    });

    // Clear old overlays
    el.innerHTML = '';

    // Build new overlays
    Object.entries(groups).forEach(([pos, arr]) => {
      if (!arr.length) return;

      const wrapper = document.createElement('div');
      wrapper.className = `product-label-overlays__stack product-label-overlays__stack--${pos}`;

      arr.forEach(l => {
        const span = document.createElement('span');
        span.className = `product-label-overlays__item product-label-overlays__item--${pos}`;
        span.title = l.alt_text || l.label_name;

        if (l.image_url) {
          const img = document.createElement('img');
          img.src = l.image_url;
          img.alt = l.alt_text || l.label_name;
          img.loading = 'lazy';
          img.className = 'product-label-overlays__img';
          span.appendChild(img);
        }

        const text = document.createElement('span');
        text.className = 'product-label-overlays__text';
        text.textContent = l.label_name;
        span.appendChild(text);

        wrapper.appendChild(span);
      });

      el.appendChild(wrapper);
    });

  } catch (e) {
    console.warn('[Overlay] Error rendering overlays:', e);
  }
}

/* ============================================================
   INITIAL LOAD (RENDER EXISTING LABELS)
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {
  const overlays = document.querySelectorAll('.product-label-overlays');
  overlays.forEach(renderProductLabelOverlays);
});


/* ============================================================
   VARIANT CHANGE HANDLING (Dawn emits product:variant-change)
   ============================================================ */

document.addEventListener('product:variant-change', (event) => {
  const variant = event.detail?.variant;
  if (!variant) return;

  // Find section
  const sectionEl = document.querySelector('.product[data-section-id]');
  const sectionId = sectionEl?.dataset?.sectionId;
  if (!sectionId) return;

  const url = `${window.location.pathname}?variant=${variant.id}&section_id=${sectionId}`;

  fetch(url)
    .then(res => res.text())
    .then(html => {
      const temp = document.createElement('div');
      temp.innerHTML = html;

      const newOverlay = temp.querySelector('.product-label-overlays');
      if (!newOverlay) {
        return;
      }

      // Collect BOTH desktop + mobile overlays
      const overlays = document.querySelectorAll('.product-label-overlays');

      overlays.forEach((overlay, index) => {

        // Update data attributes
        overlay.dataset.labels = newOverlay.dataset.labels || '[]';
        overlay.dataset.gidmap  = newOverlay.dataset.gidmap  || '{}';

        // Clear existing overlays
        overlay.innerHTML = '';

        // Re-render UI
        renderProductLabelOverlays(overlay);
      });

    })
    .catch(err => console.error('[Overlay] Error fetching updated overlay:', err));
});